// Shared styling for the dark-themed "Add Request" modals (Free Consultancy,
// AMC, Copper Piping, Sell Old AC). Pulled out into one place so every form
// looks consistent instead of each page re-inventing the same dark input /
// dialog styling.

// TextField / Select / Autocomplete field styling.
export const darkFieldSx = {
  '& .MuiInputBase-root': {
    color: '#fff',
    background: '#1c1c1c',
    borderRadius: '10px',
  },
  '& .MuiInputLabel-root': { color: '#9e9e9e' },
  '& .MuiInputLabel-root.Mui-focused': { color: '#E31E25' },
  '& .MuiOutlinedInput-notchedOutline': { borderColor: '#3a3a3a' },
  '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#5a5a5a' },
  '& .Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#E31E25' },
  '& .MuiSvgIcon-root': { color: '#9e9e9e' },
};

// Dropdown/autocomplete popup styling.
export const darkMenuPaperSx = {
  sx: {
    bgcolor: '#1c1c1c',
    color: '#fff',
    '& .MuiMenuItem-root:hover': { bgcolor: '#2a2a2a' },
    '& .Mui-selected': { bgcolor: '#2a2a2a !important' },
  },
};

// Dialog card styling — the modal shell itself.
export const darkDialogPaperProps = {
  sx: {
    background: '#1a1a1a',
    borderRadius: 3,
    border: '1px solid #2a2a2a',
    boxShadow: '0 20px 60px rgba(0,0,0,0.6)',
  },
};

// Styling for a repeated "line item" card inside a form (e.g. one AC's
// details, one photo tile) — a slightly lighter panel than the dialog
// background so it reads as a distinct group.
export const darkItemCardSx = {
  background: '#232323',
  borderRadius: 2,
  border: '1px solid #2f2f2f',
  p: 2.5,
};

export const darkTitleSx = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  color: '#fff',
  fontSize: 22,
  fontWeight: 700,
  pb: 2,
};
